<template>
  <v-autocomplete
    v-model="country"
    :items="countries"
    :placeholder="placeholder"
    :error="error"
    item-text="name"
    item-value="code"
    hide-details
    solo
    flat
    :clearable="clearable"
    :disabled="disabled"
    @input="$emit('input',$event)"
    @change="$emit('on-change',country)"
  >
    <template v-if="short" v-slot:selection="{ item, selected }">
      <span>{{ item.code }}</span>
    </template>
  </v-autocomplete>
</template>

<script>
import countryList from '@/consts/locationCountries';

export default {
  name: 'CountrySelect',
  props: {
    'prefill': null,
    'disabled': Boolean,
    'placeholder': null,
    'short': Boolean,
    'clearable': Boolean,
    'error': Boolean
  },
  data () {
    return {
      country: (this.prefill || null),
      countries: countryList 
    }
  },
  computed: {
   
  },
  methods: {
    
  }
}
</script>